import { render, staticRenderFns } from "./PermissionsEditor.vue?vue&type=template&id=6fc0ae84&scoped=true"
import script from "./PermissionsEditor.vue?vue&type=script&lang=js"
export * from "./PermissionsEditor.vue?vue&type=script&lang=js"
import style0 from "./PermissionsEditor.vue?vue&type=style&index=0&id=6fc0ae84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc0ae84",
  null
  
)

export default component.exports